export default "__VITE_ASSET__1b87bdab__"